import { tierStyle } from "@/lib/tierStyle";

const style = tierStyle("Founding Maker");

export function FoundingMakerBadge({ size = "md" }: { size?: "sm" | "md" }) {
  const sizing =
    size === "sm"
      ? "px-1.5 py-0 text-[9px] gap-0.5"
      : "px-2 py-0.5 text-[11px] gap-1 sm:px-2.5 sm:py-1 sm:text-sm";
  return (
    <span
      className={`inline-flex items-center rounded-full border font-semibold ${sizing} ${style.className}`}
      title="One of Stoop's first 50 makers"
    >
      <span aria-hidden>{style.icon}</span> Founding Maker
    </span>
  );
}
